// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

const styles = () => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mainContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  leftBottomBackground: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '30%',
    zIndex: -1,
  },
  leftTopBackground: {
    position: 'absolute',
    left: 0,
    top: 100,
    width: 100,
  },
  rightTopBackground: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: 180,
    zIndex: -1,
  },
  image: {
    maxWidth: '100%',
  },
});

export default styles;
